const SET_GENDER_DETAILS = "SET_GENDER_DETAILS";
const SET_RELATIONSHIP_DETAILS = "RELATIONSHIP_DETAILS";
const SET_EDUCATION_DETAILS = "EDUCATION_DETAILS";
const SET_OCCUPATION_DETAILS = "OCCUPATION_DETAILS";
const SET_ASSIGNMENT_OCCUPATION_DETAILS = "SET_ASSIGNMENT_OCCUPATION_DETAILS";
const SET_SALUTATION_DETAILS = "SALUTATION_DETAILS";
const SET_MARITAL_STATUS_DETAILS = "MARITAL_STATUS_DETAILS";
const SET_SUB_OCCUPATION_DETAILS = "SUB_OCCUPATION_DETAILS";
const SET_POLICY_STATUS = "SET_POLICY_STATUS";
const SET_INSURANCE_COMPANY = "SET_INSURANCE_COMPANY";
const SET_RULE_ENGINE = "SET_RULE_ENGINE";
const SET_JOINT_RELATIONSHIP_DETAILS = "SET_JOINT_RELATIONSHIP_DETAILS";
const SET_PRODUCT = "SET_PRODUCT";
const SET_PRODUCT_PARTNER = "SET_PRODUCT_PARTNER";
const SET_CHANNEL = "SET_CHANNEL";
const SET_MEF_JOURNEY_SCHEMA = "SET_MEF_JOURNEY_SCHEMA";
const SET_QUESTIONNAIRE = "SET_QUESTIONNAIRE";
const SET_LOAN_VALUES = "SET_LOAN_VALUES";

export {
  SET_GENDER_DETAILS,
  SET_EDUCATION_DETAILS,
  SET_RELATIONSHIP_DETAILS,
  SET_OCCUPATION_DETAILS,
  SET_SALUTATION_DETAILS,
  SET_MARITAL_STATUS_DETAILS,
  SET_SUB_OCCUPATION_DETAILS,
  SET_POLICY_STATUS,
  SET_INSURANCE_COMPANY,
  SET_RULE_ENGINE,
  SET_JOINT_RELATIONSHIP_DETAILS,
  SET_PRODUCT,
  SET_PRODUCT_PARTNER,
  SET_CHANNEL,
  SET_ASSIGNMENT_OCCUPATION_DETAILS,
  SET_MEF_JOURNEY_SCHEMA,
  SET_QUESTIONNAIRE,
  SET_LOAN_VALUES
};
